import { render } from "./MindUpList.vue?vue&type=template&id=00700f38&scoped=true&ts=true"
import script from "./MindUpList.vue?vue&type=script&lang=ts"
export * from "./MindUpList.vue?vue&type=script&lang=ts"

import "./MindUpList.vue?vue&type=style&index=0&id=00700f38&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00700f38"]])

export default __exports__